import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=71a674a8&scoped=true&lang=pug&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=71a674a8&prod&scoped=true&lang=css&"
import style1 from "./Header.vue?vue&type=style&index=1&id=71a674a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a674a8",
  null
  
)

export default component.exports